import { createActions, createReducer } from 'reduxsauce';
import Immutable from 'seamless-immutable';

export const INITIAL_STATE = Immutable({
  loading: false,
  loaded: false,
  sponsors: {},
  error: {},
});

const { Types, Creators } = createActions({
  getSponsors:              null,
  getSponsorsConnected:     ['sponsors'],
  getSponsorsError:         ['error'],
  getSponsorsDisconnected:  null,
});

export const getSponsorsReducer = ( state ) =>
  state.set('loading', true)

export const getSponsorsConnectedReducer = ( state, { sponsors } ) =>
  state.set('sponsors', sponsors)
       .set('loading', false)
       .set('loaded', true)

export const getSponsorsDisconnectedReducer = ( state ) =>
  state.set('loading', false)

export const getSponsorsErrorReducer = ( state, { error } ) =>
  state.set('error', error)
       .set('loading', false)

export const sponsorReducer = createReducer(INITIAL_STATE, {
  [Types.GET_SPONSORS]:              getSponsorsReducer,
  [Types.GET_SPONSORS_CONNECTED]:    getSponsorsConnectedReducer,
  [Types.GET_SPONSORS_DISCONNECTED]: getSponsorsDisconnectedReducer,
  [Types.GET_SPONSORS_ERROR]:        getSponsorsErrorReducer,
})


export const SponsorTypes = Types
export default Creators;


// WEBPACK FOOTER //
// ./src/reducers/sponsorReducer.js